<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="filter-wrapper">
          <p class="title">Manage Filters:</p>
            <div class="filter-container clearfix">
              <div class="filter-item search-filter">
                <input
                  v-model="filters.item_model"
                  :disabled="loadingItems"
                  type="text"
                  placeholder="Item"
                  @change="filterList">
                <button
                  :disabled="loadingItems"
                  type="button"
                  @click="filterList"><i class="fa fa-search"></i></button>
              </div>
              <div class="filter-reset-btn">
                <a
                  :class="{ 'disabled-link': loadingItems }"
                  href="javascript:void(0)"
                  title="Refresh"
                  @click="resetFilter">
                  <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                </a>
              </div>
              <div class="float-right">
                <button
                  :disabled="loadingItems"
                  class="btn btn-new-lead pt-2 pb-2 rounded"
                  @click="handleClickAdd">
                  <span class="fas fa-plus-square">&nbsp;</span> New Lead Time
                </button>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive">
          <div id="lead-time-items" class="list-proj" @scroll="scrollProj">
            <div class="row list-head">
              <div class="col sort-false" data-key="item_num">#</div>
              <div class="col sort-false" data-key="item_model">Machine Model_No</div>
              <div class="col sort-false" data-key="lead_time_week">Lead Time<br>(by Weeks)</div>
              <div class="col sort-false" data-key="formatted_cat">Date Created</div>
              <div class="col sort-false" data-key="formatted_uat">Date Updated</div>
              <div class="col sort-false">Actions</div>
            </div>
            <div class="list-row" v-for="(row, index) in leadTimeItems" :key="row.id">
              <div class="row list-data">
                <div class="col">{{ ++index }}</div>
                <div class="col">{{ row.item_model }}</div>
                <div class="col">{{ row.lead_time_week }}</div>
                <div class="col">{{ row.formatted_cat }}</div>
                <div class="col">{{ row.formatted_uat || `-` }}</div>
                <div class="col">
                  <a
                    href="javascript:void(0);"
                    @click="handleClickEdit(row)">Edit</a>
                </div>
            </div>
            </div>
          </div>
          <template v-if="leadTimeItems.length == 0 && !loadingItems">
              <p class="no-results-msg">No results found</p>
          </template>
          <template v-if="loadingItems">
              <div class="progress">
                  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
              </div>
          </template>
      </div>
      </div>
    </div>
    <modal 
      id="item-lead-modal"
      v-if="openItemLoadModal"
      :show="openItemLoadModal"
      :closeOnbackdrop="false"
      @close="handleClose">
        <template slot="header">
            <h4 style="color: white;">
              <span v-if="isEdit">Edit Item Lead Time: {{ editItemTitle }}</span>
              <span v-else>New Item Lead Time</span>
            </h4>
        </template>
        <template>
          <form
            ref="itemLeadForm"
            class="itme-lead-form"
            autocomplete="off"
            @submit.prevent="handleClickSave">
            <div class="row">
              <div class="form-group col-md-12 col-xs-12 col-lg-12">
                <label>Item Model Number:</label>
                <select
                  ref="item_lead_model"
                  v-model="currentItemLead.item_model"
                  required
                  :class="{ 'has-default-option': isAdd && currentItemLead.item_model === null }"
                  class="form-control">
                  <option v-if="isAdd" selected :value="null" class="empty-option">Select machine model number</option>
                  <option v-for="modelNumber in machineModelNumbers" :key="modelNumber.ID" :value="modelNumber.Model_No">{{ modelNumber.Model_No }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12 col-xs-12 col-lg-12">
                <label>Lead Time (by Week):</label>
                <input ref="item_lead_time" v-model="currentItemLead.lead_time_week" type="number" required max="255" class="form-control" placeholder="Input lead time by week">
              </div>
            </div>
          </form>
          <div style="margin-top: 10px; float: right;">
            <template>
              <a class="btn btn-black custom" @click="handleClose">Cancel</a>
              <a class="btn btn-black custom" @click="handleClickSave">
                <template v-if="saveButton.saving"><span  class="fa fa-spinner fa-pulse">&nbsp;</span></template>
                <span>{{ saveButton.text }}</span>
              </a>
            </template>
          </div>
          <div class="clearfix"></div>
        </template>
    </modal>
  </div>
</template>
<script>
import { ItemLead } from '../../../api/itemleadtime/itemlead.js'
export default {
  name: 'ItemLeadTimeList',
  data() {
    return {
      loadingItems: false,
      leadTimeItems: [],
      filters: {
        item_model: null,
        page: 1
      },
      user: {},
      currentItemLead: {
        item_model: null,
        lead_time_week: null
      },
      saveButton: {
        text: 'Submit',
        saving: false
      },
      openItemLoadModal: false,
      isAdd: false,
      isEdit: false,
      stopLoads: false,
      errors: [],
      editItemTitle: '',
      machineModelNumbers: [],
      loadingMachineNumbers: false
    }
  },
  mounted() {
    document.getElementById("lead-time-items").addEventListener('scroll', this.scrollProj);
  },
  beforeMount(){
    this.getMachineModelNumbers()
    this.getLeadTimeItems()
  },
  methods: {
    scrollProj({ target: { scrollTop, clientHeight, scrollHeight }}) {
      if (scrollTop + clientHeight >= (scrollHeight - 100) && !this.stopLoads && !this.loadingItems) {
        this.filters.page += 1;
        this.getLeadTimeItems();
      }
    },
    getMachineModelNumbers() {
      this.loadingMachineNumbers = true
      ItemLead({}, 'get', 'model-numbers').then(response => {
        this.machineModelNumbers = response.data.machine_model_numbers
        this.loadingMachineNumbers = false
      }).catch(() => {
        this.loadingMachineNumbers = false
      })
    },
    getLeadTimeItems() {
      this.loadingItems = true
      if ( this.filters.page == 1 ) {
        this.leadTimeItems = [];
        this.stopLoads = false;
      }

      ItemLead(this.filters).then(response => {

        if ( this.filters.page == 1 ) this.leadTimeItems = response.data.lead_time_items;
        else this.leadTimeItems = this.leadTimeItems.concat(response.data.lead_time_items);
        if ( !response.data.lead_time_items.length ) this.stopLoads = true;

        this.loadingItems = false
      })
      .catch(() => {
        this.loadingItems = false
      })
    },
    filterList() {
      this.filters.page = 1
      this.getLeadTimeItems()
    },
    resetFilter() {
      this.filters = {
        item_model: null,
        page: 1
      }
      this.getLeadTimeItems()
    },
    handleClose() {
      this.openItemLoadModal = false
      this.isAdd = false
      this.isEdit = false
      this.editItemTitle = ''
      this.resetCurrentTimeLead()
    },
    handleClickAdd() {
      this.isAdd = true
      this.openItemLoadModal = true
    },
    handleClickEdit(row) {
      this.currentItemLead = Object.assign({}, row)
      this.editItemTitle = this.currentItemLead.item_model
      this.isEdit = true
      this.openItemLoadModal = true
    },
    handleClickSave() {
      this.saveButton.saving = true;
      this.saveButton.text = 'Saving';
      if ( !this.checkData('itemLeadForm') ) {
        this.saveButton.saving = false;
        this.saveButton.text = 'Submit';
        return false;
      }
      const action = this.currentItemLead.id ? 'put' : 'post'
      ItemLead(this.currentItemLead, action).then(() => {
        this.resetFilter()
        this.resetSaveButton()
        this.handleClose()
      }).catch(error => {
        if (error.response.data.message === 'validation_error') {
          this.errors = error.response.data.errors
          this.validation_error(this.errors)
        }
        this.resetSaveButton()
      })
    },
    validation_error(errors) {
      let erHasError = false;
      let message = [];
      let erRef = null;
      for(let er in errors) {
        if (er === 'item_model') {
          erHasError = true;
          erRef = this.$refs['item_lead_model']
          message = message.concat(errors[er])
        } else if (er === 'lead_time_week') {
          erHasError = true;
          erRef = this.$refs['item_lead_time']
          message = message.concat(errors[er])
        }
        if (erHasError) erRef.classList.add('hasError')
      }
      if (erHasError) {
        alert(message.join('\r\n'))
      }
    },
    checkData(ref){
      let hasEmpty = false,
        firstEl = false;

      const length = this.$refs[ref].elements.length;
      for (let i = 0; i <= length - 1; i++) {
        const el = this.$refs[ref].elements[i];
        if (el.required && (el.value === '' || el.value === undefined)) {
          hasEmpty = true;
          if ( !firstEl ) firstEl = el;
          el.classList.add('has-error');
        } else {
          if (el.classList.contains('has-error')) {
            el.classList.remove('has-error');
          }
        }
      }

      if ( hasEmpty ) {
        alert('Please fill all required data.');
        firstEl.focus();
        return false;
      }
      return true;
    },
    resetSaveButton() {
      this.saveButton.saving = false
      this.saveButton.text = 'Submit'
    },
    resetCurrentTimeLead() {
      this.currentItemLead = {
        item_model: null,
        lead_time_week: null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .itme-lead-form .has-error{
    outline: 1px solid red !important;
    z-index: 2 !important;
    background: #ffe9e9 !important;
    border-color: red !important;
  }
  .disabled-link {
    pointer-events: none !important;
  }
  .btn-black.custom {
    border: 0;
    background-color: #000;
    color: #FFF;
    &:hover, &:focus {
        color: #000;
        background: linear-gradient(174deg, rgba(220,220,220,1) 0%, rgba(255,255,255,1) 100%);
    }
  }
  a.btn-black.custom {
      color: #FFF !important;
      text-decoration: none !important;
      &:hover, &:focus {
          text-decoration: none !important;
          color: #000 !important;
      }
  }
  #lead-time-items {
    min-width: 700px;
    padding-right: 12px;
    max-height: 500px;
    .list-head .col {
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url('/api/public/img/bg.png');
        background-position: center right;
        background-repeat: no-repeat;
        cursor: pointer;
        white-space: normal;
        &.asc {
            background-image: url('/api/public/img/trans-asc.png');
        }
        &.desc {
            background-image: url('/api/public/img/trans-desc.png');
        }
        &.sort-false {
            background-image: none;
            cursor: default;
        }
    }
  }
  .progress {
    border-radius: 0;
  }
  .no-results-msg {
      text-align: center;
      padding: 0.5em;
      font-size: 11px;
  }
  .col-check-th,
  .col-check-td {
      flex-grow: 0;
  }
  .col-check-th {
      padding-left: 32px;
  }
  .col-check-td {
      padding-left: 25px;
  }
  .has-default-option {
    color: #aeb6be !important;
  }
  .has-default-option > option:not(:first-child) {
    color: black !important;
  }
  .empty-option {
    color: #aeb6be !important;
  }
</style>
